import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ProductList } from './productList/product-list';
import styled from 'styled-components';
import { Icon } from '@purpurds/purpur/icon';
import { icons } from 'theme/icons';
import { PurPurButton } from 'components';
import { purpurColorRed600 } from '@purpurds/tokens/color/variables';
import spacing from 'theme/spacing';
const ListTop = styled.div `
  width: 100%;
  min-width: 320px;
  max-width: 640px;
  margin: ${spacing.spacing20} 0 ${spacing.spacing8};
`;
const Navigation = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${spacing.spacing16};
`;
const ButtonWrapper = styled.div `
  width: 44px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const NumberWrapper = styled.span `
  position: absolute;
  min-width: 18px;
  text-align: center;
  margin-left: 90px;
  padding: 2px 5px;
  color: ${purpurColorRed600};
  border: 1px solid ${purpurColorRed600};
  border-radius: 50%;
`;
const StyledTitle = styled.span `
  font-style: normal;
  font-weight: 500;
  font-size: 25px;
`;
export const WorkOrderListTop = ({ hideProductList = false, productList, onNextClick, onPrevClick, title, numberOfElementsPrevPage, }) => {
    const hasPrevElements = (numberOfElementsPrevPage !== null && numberOfElementsPrevPage !== void 0 ? numberOfElementsPrevPage : 0) > 0;
    const hasProducts = productList && Object.keys(productList).length > 0;
    const prevButton = (_jsx(ButtonWrapper, { children: _jsxs(PurPurButton, { iconOnly: true, "aria-label": '', variant: 'tertiary-purple', size: 'lg', onClick: onPrevClick || undefined, disabled: !onPrevClick, children: [_jsx(Icon, { svg: icons.chevronLeft }), hasPrevElements && (_jsx(NumberWrapper, { children: numberOfElementsPrevPage }))] }) }));
    const nextButton = (_jsx(ButtonWrapper, { children: _jsx(PurPurButton, { iconOnly: true, "aria-label": '', variant: 'tertiary-purple', size: 'lg', onClick: onNextClick || undefined, disabled: !onNextClick, children: _jsx(Icon, { svg: icons.chevronRight }) }) }));
    return (_jsxs(ListTop, { children: [_jsxs(Navigation, { children: [prevButton, _jsx(StyledTitle, { children: title }), nextButton] }), !hideProductList && hasProducts && (_jsx(ProductList, { productList: productList }))] }));
};
